import React, { useEffect } from "react";
import { inProduction } from "../../../../../../config";
import { SHA256 } from "utils/utils";
import { SpeciesEnum } from "../../../../../../__generated__/globalTypes";
import hash from "utils/hash";
import { useAllValidAnimals } from "components/Signup/store/selectors/animals";
import { ThankYouView } from "components/Signup/components/ThankYou/ThankYouView";
import { useCustomer } from "components/Signup/store/selectors/customer";

const ThankYou = () => {
  const animals = useAllValidAnimals();

  const { email } = useCustomer();

  useEffect(() => {
    const script = document.createElement("script");

    // The script only allows for tracking one animal/insurance. If they can
    // offer a tracking pixel this can be updated to be a loop.
    const animal = animals[0];
    const insurance = animal.insurances[0];

    if (insurance.policy && inProduction) {
      SHA256(insurance.policy.policyNumber).then((hashedPolicyNumber) => {
        script.src = "https://ion.lassie.co/jsTag?ap=1644319678";
        script.defer = true;

        (window as any).ADT = (window as any).ADT || {};
        (window as any).ADT.Tag = (window as any).ADT.Tag || {};
        (window as any).ADT.Tag.t = 3;
        (window as any).ADT.Tag.c = "SEK";
        (window as any).ADT.Tag.tp =
          animal.species === SpeciesEnum.dog ? 1644323373 : 1644323632;
        (window as any).ADT.Tag.am = 0;
        (window as any).ADT.Tag.ti = hashedPolicyNumber;
        (window as any).ADT.Tag.xd = hash.md5(email ?? "");

        document.body.appendChild(script);
      });
    }

    return () => {
      if (insurance.policy && inProduction) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return <ThankYouView showMultipetBanner showTractiveBanner />;
};

export default ThankYou;
